(function($) {
	$( document ).ready(
		function() {
      const el = document.querySelector(".header")
			if(el) {
				const observer = new IntersectionObserver(
					([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
					{ threshold: [1] }
				);

				observer.observe(el);
			}

      var viewport = document.documentElement.clientWidth

			$( 'a[href="#"]' ).click(
				function(e) {
					e.preventDefault()
				}
			);

      $('a.newTab, .newTab > a').each(function(index, el) {
        $(this).attr('target', '_blank');
      });

			// var myElement = document.querySelector(".nav");
			// if (myElement) {
			// var headroom  = new Headroom(myElement, {
			// "offset": $(myElement).outerHeight(),
			// });

			// headroom.init();
			// }

			// $( '.hamburger' ).click(
			// 	function() {
			// 		$( this ).toggleClass( 'is-active' )
			// 		$( '.navRight' ).toggleClass( 'is-active' );
			// 	}
			// );

      $('.nav-menu').click(function(e) {
        e.preventDefault()
        $(this).toggleClass('active');
        $('.navContainer').toggleClass('active');
        $('body').toggleClass('u-noScroll');
      });

      if (viewport < 1190) {
        $('.nav-primary .menu-item.menu-item-has-children').append('<div class="subnav-toggle"></div>')

        $('.nav-primary .menu-item.menu-item-has-children .subnav-toggle').click(function(event) {
          event.preventDefault()
          $(this).closest('.menu-item').toggleClass('active')
        });
      }

			var link = document.querySelector( ".skipNavigation-link" );

			if (link) {
				link.addEventListener(
					"focus",
					function() {
						link.parentElement.classList.add( "focus" );
					}
				);
				link.addEventListener(
					"blur",
					function() {
						  link.parentElement.classList.remove( "focus" );
					}
				);
			}
		}
	)
})( jQuery );
